(function() {
    'use strict';

    angular.module("imApp").factory("stockReplenishmentDetailService", [function() {
        var service = {

        }

        return service;
    }]);
})();
